const FEATURES = [
  {
    icon: 'ri-smartphone-line',
    title: '下拉式流畅阅读',
    desc: '采用无限下拉翻页技术，无需跳转页面，阅读体验如丝般顺滑。移动端和桌面端均完美适配，追漫不卡顿。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '热门连载漫画每日第一时间同步更新，韩漫、日漫、国漫三线并行，确保读者永不落更、追更无忧。',
  },
  {
    icon: 'ri-stack-line',
    title: '全类型覆盖',
    desc: '20余个细分品类、30000+部漫画资源，从悬疑到恋爱、从搞笑到奇幻，每一种口味都能在这里找到归宿。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            阅读特色
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            为什么漫画爱好者选择谜妹
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {FEATURES.map((feature, idx) => (
            <div
              key={idx}
              className="group text-center p-6 md:p-8 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${feature.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}